import axios from "@/utils/request.js";
import qs from "qs"
// 获取闯关详情无token
export const getBreakthroughDetailNo = (params) => axios({
    url: "/api/web-operate/platform/breakthrough/detailNoToken",
    method: 'get',
    params
})
//获取闯关详情有token
export const getBreakthroughQuestion = (params) => axios({
    url: "/api/web-operate/platform/breakthrough/questions",
    method: 'get',
    params
})
//答案检验
export const getBreakthroughAnswer = (params) => axios({
    url: "/api/web-operate/platform/breakthrough/checkAnswer",
    method: 'get',
    params
})
//排行榜
export const getBreakthroughRank = (params) => axios({
    url: "/api/web-operate/platform/breakthrough/rank/page",
    method: 'get',
    params
})